import type { RouteRecordRaw } from 'vue-router';

export const SIGNUP = 'signup';

const routes: RouteRecordRaw[] = [
  {
    path: '',
    name: SIGNUP,
    component: () => import('./pages/SignupPage.vue'),
  },
];
export default routes;
